(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["joud-scroll-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
  const main = document.getElementById('MainContent');
  if (!main || main.dataset.joudMotionReady || !('IntersectionObserver' in window)) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches || window.Shopify?.designMode) return;
  main.dataset.joudMotionReady = 'true';
  const selectors = [
    '[hdt-reveal]',
    '[t4s-reveal]',
    '.t4s-collection-item > .t4s-cat-content',
    '.t4s-page-item-inner',
    '.joud-picks__heading',
    '.joud-pick',
    '.joud-worlds__head',
    '.joud-worlds__card',
    '.joud-story__shell',
    '.jwd-trust__item',
    '.jwd-b2b__card',
    '.joud-wd-ci__inner',
    '.joud-wd-cb__head',
    '.joud-wd-cb__grid',
    '.joud-wd-px__head',
    '.joud-wd-px__grid',
    '.joud-wd-px__bulk',
    '.joud-contact__intro',
    '.joud-contact__info',
    '.t4s-desc-collection',
    '.t4s-product__description',
    '.t4s-article-title',
    '.t4s-article-image',
    '.t4s-article-content :is(h2,h3,p,ul,ol,blockquote,figure,table)',
    '.template-page .t4s-rte :is(h1,h2,h3,p,ul,ol,blockquote,figure,table)',
    '.shopify-policy__title',
    '.shopify-policy__body .rte > :is(h2,h3,p,ul,ol,blockquote)',
    '.t4s-product-wrapper'
  ].join(',');
  const excluded = '.joud-hero-slider,.flickity-viewport,.flickityt4s,.t4s-sticky-atc,.joud-pdp-sticky-buy,.t4s-drawer,[role="dialog"],form,.t4s-pagination-wrapper,.t4s-prs-footer,.t4s-blog-footer,.t4s-prs-head,.t4s-prev-head,.t4s-product-form__buttons,.t4s-product__media-wrapper';
  const seen = new WeakSet();
  const pending = new Set();
  const running = new Map();
  let frame = 0;
  let disabled = false;
  const added = new Set();
  let observer;
  let changes;
  const toolbar = document.querySelector('.t4s-toolbar');
  const bottomInset = Math.max(56, (toolbar?.getBoundingClientRect().height || 0) + 20);

  function finish(element) {
    observer?.unobserve(element);
    pending.delete(element);
    clearTimeout(running.get(element));
    running.delete(element);
    element.classList.remove('joud-reveal-pending','joud-reveal-running');
    element.style.removeProperty('--joud-reveal-delay');
    element.dataset.joudReveal = 'done';
  }

  function reveal(element, immediate = false) {
    if (!element.isConnected || immediate || disabled || motion.matches) {
      finish(element);
      return;
    }
    observer.unobserve(element);
    pending.delete(element);
    element.classList.remove('joud-reveal-pending');
    element.classList.add('joud-reveal-running');
    element.dataset.joudReveal = 'revealing';
    running.set(element, setTimeout(() => finish(element), 1900));
  }

  function stop() {
    disabled = true;
    observer?.disconnect();
    changes?.disconnect();
    cancelAnimationFrame(frame);
    added.clear();
    [...pending,...running.keys()].forEach(finish);
  }

  function register(scope) {
    const candidates = scope.matches?.(selectors) ? [scope] : [];
    candidates.push(...scope.querySelectorAll(selectors));
    candidates.forEach(element => {
      if (seen.has(element) || element.closest(excluded) || element.matches('.t4s-product,.t4s-post-item') || element.querySelector('form,[role="dialog"]')) return;
      if (element.matches('.t4s-article-content,.template-page .t4s-rte,.shopify-policy__body') || element.querySelector('.t4s-article-content,.template-page .t4s-rte,.shopify-policy__body')) return;
      if (element.parentElement?.closest('[data-joud-reveal]')) return;
      if (!element.getClientRects().length) return;
      seen.add(element);
      const bounds = element.getBoundingClientRect();
      const railBounds = element.closest('.joud-picks__rail')?.getBoundingClientRect();
      const visibleLeft = Math.max(0, railBounds?.left || 0);
      const visibleRight = Math.min(window.innerWidth, railBounds?.right ?? window.innerWidth);
      const alreadyVisible = bounds.top < window.innerHeight - bottomInset && bounds.right > visibleLeft && bounds.left < visibleRight;
      if (bounds.bottom <= 0 || alreadyVisible || element.contains(document.activeElement)) {
        element.dataset.joudReveal = 'done';
        return;
      }
      const card = element.closest('.t4s-product,.t4s-post-item,.t4s-collection-item,.t4s-page-item,.joud-pick,.joud-worlds__card,.jwd-trust__item');
      if (card?.parentElement) {
        const index = Array.from(card.parentElement.children).indexOf(card);
        element.style.setProperty('--joud-reveal-delay', `${(index % 4) * 160}ms`);
      }
      element.dataset.joudReveal = 'pending';
      pending.add(element);
      observer.observe(element);
      element.classList.add('joud-reveal-pending');
    });
  }

  function uncover(target) {
    if (!(target instanceof Element)) return;
    const parent = target.closest('[data-joud-reveal]');
    if (parent) finish(parent);
    target.querySelectorAll('[data-joud-reveal="pending"],[data-joud-reveal="revealing"]').forEach(finish);
  }

  try {
    observer = new IntersectionObserver(entries => {
      try {
        entries.forEach(entry => { if (entry.isIntersecting) reveal(entry.target); });
      } catch { stop(); }
    }, { rootMargin:`0px 0px -${bottomInset}px 0px`, threshold:0.08 });
    register(main);
    changes = new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node instanceof Element && !node.closest(excluded)) added.add(node);
      }));
      const removed = records.some(record => record.removedNodes.length);
      if ((!added.size && !removed) || frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        try {
          added.forEach(node => { if (node.isConnected) register(node); });
          added.clear();
          pending.forEach(node => { if (!node.isConnected) finish(node); });
        } catch { stop(); }
      });
    });
    changes.observe(main, { childList:true, subtree:true });
    main.addEventListener('animationend', event => {
      if (event.animationName === 'joud-reveal-in') finish(event.target);
    });
    main.addEventListener('focusin', event => uncover(event.target));
    window.addEventListener('hashchange', () => {
      try { uncover(document.getElementById(decodeURIComponent(location.hash.slice(1)))); } catch { stop(); }
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted || disabled) return;
      [...running.keys()].forEach(finish);
      pending.forEach(element => {
        observer.unobserve(element);
        observer.observe(element);
      });
    });
    motion.addEventListener('change', event => { if (event.matches) stop(); });
  } catch { stop(); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once:true });
  } else {
    initialize();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
